if (window.matchMedia('(pointer: coarse)').matches) {
  document.querySelector('html').classList.add('touchevents');
} else {
  document.querySelector('html').classList.add('no-touchevents');
}
